import { AuthMachineContext } from "@/store/machine/authMachine/authMachine";
import { AuthEventType } from "@/types/auth";
import { cn } from "@/utils/styles";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import React from "react";
import { trackEvent } from "@/utils/analytics";
import { AnalyticsEventType } from "@/constants/analytics";

type SignupSkipButtonProps = {
  disabled?: boolean;
};

export const SignupSkipButton: React.FC<SignupSkipButtonProps> = ({ disabled }) => {
  const authActorRef = AuthMachineContext.useActorRef();

  return (
    <a
      onClick={() => {
        trackEvent(AnalyticsEventType.SKIP_THIS_STEP_CLICKED, {
          url: window.location.href
        });
        authActorRef.send({
          type: AuthEventType.SKIP_STEP
        });
      }}
      className={cn(
        "label-small flex cursor-pointer flex-row items-center gap-1 text-gray-dark-1000 hover:text-white",
        disabled ? "pointer-events-none" : ""
      )}
    >
      <span>Skip This Step</span>
      <ChevronRightIcon className="h-[14px]" />
    </a>
  );
};
